import React from 'react';
import { Box, Stack, Typography } from '@mui/material';

interface IASectionBarProps {
  label: string;
  right?: React.ReactNode;
}

const IASectionBar: React.FC<IASectionBarProps> = ({ label, right }) => (
  <Stack
    direction={'row'}
    alignItems={'center'}
    spacing={1.5}
    sx={{ mb: 2 }}
  >
    <Typography sx={{ fontSize: 18, fontWeight: 700 }}>{label}</Typography>
    {right && (
      <Typography sx={{ color: 'text.secondary', fontSize: 13 }}>
        {right}
      </Typography>
    )}
    <Box sx={{ flex: 1 }} />
  </Stack>
);

export default IASectionBar;
